export enum BenefitsAction {
  NewBenefits = "New benefits",
  FetchBenefits = "Fetch benefits",
  InsertBenefits = "Insert Benefits",
  SetState = 'Set benefits state'
}
